import Vue from 'vue'
// const heightTable = {
//     install (Vue) {
        Vue.directive('height', {
            inserted(el) {
                // const paginationRef = vnode.context.$refs.paginationRef
                const calculateHeight = () => {
                    const windowHeight = window.innerHeight
                    const topOffset = el.getBoundingClientRect().top
                    const otherElementsHeight = 20
                    // console.log(paginationRef)
                    // let paginationHeight = 0
                    // if (paginationRef && paginationRef.totalPage) {
                    //     paginationHeight = 72
                    // }
                    let table_height = windowHeight - topOffset - otherElementsHeight - 62
                    // if (table_height < 300) {
                    //     table_height = 300
                    // }
                    el.style.height = `${table_height}px`
                }
                const debouncedCalculateHeight = debounce(calculateHeight, 200)
                debouncedCalculateHeight()
                window.addEventListener('resize', debouncedCalculateHeight)
                el.__vueHeightDirective__ = debouncedCalculateHeight
            },
            unbind(el) {
                window.removeEventListener('resize', el.__vueHeightDirective__)
                delete el.__vueHeightDirective__
            }
        })
//     }
// };
export const debounce = (func, wait) => {
    let timeout;
    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            func.apply(context, args);
        }, wait);
    };
}
    // }
// };
// export default heightTable;
